import React from "react";
import { NavLink } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaYoutube, FaFilePdf, FaFile } from "react-icons/fa"

import './NavLinks.css';

const NavLinks = function (props) {
    return (
        <React.Fragment>
            <ul className="nav-links">
                <li>
                    <NavLink to="/" exact="true">Verein</NavLink>
                </li>
                <li>
                    <NavLink to="/sparten" exact="true">Sparten</NavLink>
                </li>
                {/* <li>
                    <NavLink to="/blog" exact="true">Blog</NavLink>
                </li> */}
                <li>
                    <NavLink to="/faq" exact="true">FAQ</NavLink>
                </li>
                {/* <li className="dropdown">
                    <span className="label">Social Links</span>
                    <ul className="items">
                        <li>
                            <a href="https://www.instagram.com/combatsports_hl/" target="_blank" rel="noreferrer"><FaInstagram className="icon-link" /> Instagram</a>
                        </li>
                        <li>
                            <a href="https://de-de.facebook.com/combat.sports.luebeck/" target="_blank" rel="noreferrer"><FaFacebook className="icon-link" /> Facebook</a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/c/CombatsportsDeHL" target="_blank" rel="noreferrer"><FaYoutube className="icon-link" />Youtube</a>
                        </li>
                    </ul>
                </li> */}
                <li>
                    {/* <a href="https://www.instagram.com/combatsports_hl/" target="_blank" rel="noreferrer">
                        <span className="dropdown">
                            <span className="label"><FaInstagram className="icon-link" /></span>
                            <ul className="items">
                                <li>
                                    <a href="https://www.instagram.com/combatsports_hl/" target="_blank" rel="noreferrer"><FaInstagram className="icon-link" /> <span>Combat Sports Lübeck</span></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/combatsports_mma/" target="_blank" rel="noreferrer"><FaInstagram className="icon-link" /> <span>Combat Sports MMA</span></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/revengers_bb/?hl=en" target="_blank" rel="noreferrer"><FaInstagram className="icon-link" />  <span >Revengers BB</span></a>
                                </li>
                            </ul>
                        </span>
                    </a> */}
                    <a className="a-icon-link" href="https://www.instagram.com/combatsports_hl/" target="_blank" rel="noreferrer"><FaInstagram className="icon-link" /></a>
                    <a className="a-icon-link" href="https://de-de.facebook.com/combat.sports.luebeck/" target="_blank" rel="noreferrer"><FaFacebook className="icon-link" /></a>
                    <a className="a-icon-link" href="https://www.youtube.com/c/CombatsportsDeHL" target="_blank" rel="noreferrer"><FaYoutube className="icon-link" /></a>
                </li>

            </ul>

        </React.Fragment >

    )
};

export default NavLinks;

